import { ChangeEvent } from "react";

import { Specimen } from "pwapi";

import { selectFeatureFlag } from "shared/reducers/sysReducer";
import { procedureEnumToLabel } from "shared/utils/specimenUtils";

import DateRangeInput from "components/customInputs/DateRangeInput";
import SelectInput from "components/customInputs/SelectInput";
import TextInput from "components/customInputs/TextInput";
import { useAppSelector } from "store/hooks";

import {
  FilterLabels,
  FilterOptions,
  SpecimenFiltersState,
} from "../casesTable/CaseAdminFilters.contracts";

type SpecimenFiltersProps = SpecimenFiltersState & {
  onChange: Function;
  onChangeDateRange: Function;
};

export const mapSpecimensFilterToLabel: FilterLabels<SpecimenFiltersState> = {
  specimensBiopsyType: "WPL Specimen Biopsy Type",
  specimensProcedure: "Specimen Procedure",
  specimensType: "Specimen Type",
  specimensSource: "WPL Specimen Source",
  specimensSite: "Specimen Site",
  grossCompletedAfter: "WPL Gross Date",
  grossCompletedBefore: "WPL Gross Date",
};
export const mapSpecimensFilterToOptions: FilterOptions<SpecimenFiltersState> =
  {
    specimensBiopsyType: Object.values(Specimen.biopsy_type).map((v) => ({
      label: v,
      value: v,
    })),
    specimensProcedure: Object.values(Specimen.procedure).map((v) => ({
      label: procedureEnumToLabel(v) || "",
      value: v,
    })),
    specimensType: Object.values(Specimen.type).map((v) => ({
      label: v,
      value: v,
    })),
  };
const SpecimenFilters = (props: SpecimenFiltersProps) => {
  const adminWPLFilters = useAppSelector((state) =>
    selectFeatureFlag(state, "adminWPLFilters")
  );
  return (
    <>
      {adminWPLFilters && (
        <>
          <DateRangeInput
            id="grossCompleted"
            label={mapSpecimensFilterToLabel["grossCompletedAfter"]}
            values={{
              from: {
                id: "grossCompletedAfter",
                name: "gross_completed_after",
                value: props.grossCompletedAfter,
              },
              to: {
                id: "grossCompletedBefore",
                name: "gross_completed_before",
                value: props.grossCompletedBefore,
              },
            }}
            onChangeDate={props.onChangeDateRange}
            isClearable
          />
          <TextInput
            id="specimensSource"
            value={props.specimensSource}
            label={mapSpecimensFilterToLabel["specimensSource"]}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              props.onChange("specimensSource", e.target.value || "")
            }
            onClear={() => props.onChange("specimensSource", "")}
          />
          <SelectInput
            id="specimensBiopsyType"
            label={mapSpecimensFilterToLabel["specimensBiopsyType"]}
            defaultLabel="All Types"
            options={mapSpecimensFilterToOptions["specimensBiopsyType"]}
            value={props.specimensBiopsyType}
            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
              props.onChange("specimensBiopsyType", e.target.value || "")
            }
          />
        </>
      )}
      <SelectInput
        id="specimensType"
        label={mapSpecimensFilterToLabel["specimensType"]}
        defaultLabel="All Types"
        options={mapSpecimensFilterToOptions["specimensType"]}
        value={props.specimensType}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          props.onChange("specimensType", e.target.value || "")
        }
      />
      <TextInput
        id="specimensSite"
        value={props.specimensSite}
        label={mapSpecimensFilterToLabel["specimensSite"]}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          props.onChange("specimensSite", e.target.value || "")
        }
        onClear={() => props.onChange("specimensSite", "")}
      />
      <SelectInput
        id="specimenProcedure"
        label={mapSpecimensFilterToLabel["specimensProcedure"]}
        defaultLabel="All Procedures"
        options={mapSpecimensFilterToOptions["specimensProcedure"]}
        value={props.specimensProcedure}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          props.onChange("specimensProcedure", e.target.value || "")
        }
      />
    </>
  );
};

export default SpecimenFilters;
